
/**多语言配置说明 https://segmentfault.com/a/1190000014229902 */
//意大利
export const lang ={
  Please_set_materialtype_in_product_page:"Vai alla pagina prodotto per modificare e impostare la tipologia materiale di ciascun prodotto - prodotti finiti - semilavorati - accessori.",
deleteAccount:"Disconnettersi",
deleteAccountWillDeleteAllData:"La disconnessione dal tuo account cancellerà tutti i dati e ti impedirà di accedere.",
backupDatabase:"banca dati di backup",
restoreDatabase:"Ripristinare il database",
materialtype:"Tipo di materiale",
Manufacturing:"Versione di produzione",
Professional:"Versione professionale",
Standard:"edizione standard",
product:"Prodotto finito",
halfProduct:"Prodotti semi-finiti",
components:"Accessori",
Parent:"componente genitore",
Children:"Sottoaccessori",
Level:"Gerarchia",
Timing:"Tempistica",
PieceCount:"Lavoro a cottimo",
Wages:"Salari",
InternalProcess:"Processo interno",
ExternalProcess:"processo esterno",
ProceName:"Nome del processo",
ProceIndex:"Ordine di esecuzione",
ChargeMan:"principale",
BillMethod:"Metodo di fatturazione",
ConsumTime:"ore lavorative",
Accessories:"Accessori",
Assembly:"Assemblare",
materials:"materiali",
task:"Compito",
process:"processi",
BOM:"Distinta base",
Production:"Produzione",
RestorePurchaseOneUse:"Ripristina acquisto (un utente (limitato agli acquisti precedenti))",
buy_fail_try_again:"Fare nuovamente clic per acquistare",
Export:"Esportare",
Date:"data",
BankDetail:"coordinate bancarie",
Seller:"venditore",
Buver:"acquirente",
Currency:"valuta",
CompanyName:"Nome della ditta",
ProformaInvoice:"fattura proforma",
Discount:"Sconto",
PayStatus:"Stato del pagamento",
ShippingStatus:"Stato della spedizione",
FreightType:"Tipo di trasporto",
Shipping:"trasporto",
Payment:"Pagamento",
Moneyname:"nome della valuta",
Tax:"le tasse",
Freight:"Spese di trasporto",
Insurance:"assicurazione",
Bankfee:"tasse bancarie",
Qc:"Certificazione di qualità",
Exchangerate:"tasso di cambio",
Shippingnumber:"numero di spedizione",
ShipDate:"Data di spedizione",
Arrivedate:"data d'arrivo",
Grossweight:"peso lordo",
CubicWeight:"peso cubico",
Totalpackages:"Numero totale di pacchi",
Moneytype:"tipo di valuta",
Quotedate:"data di citazione",
Validitydate:"Data valida",
Paymentterm:"scadenza della retribuzione",
Priceterm:"termine di prezzo",
DeliveryTerm:"Tempi di consegna",
BankName:"nome della banca",
BankAddress:"indirizzo bancario",
SwiftCode:"Codice bancario",
Review:"Revisione",
Signfor:"Firmare per ricevuta",
Finance:"finanza",
Receiver:"Ricevitore",
Business:"Attività commerciale",
ContactPerson:"Referente",
Profit:"profitto",
Staff_must_use_in_browser_please_check_the_address_in_help_page:"I dipendenti devono utilizzare Google Chrome. Controlla l'indirizzo IP nella pagina di aiuto dell'APP del computer di servizio principale, quindi inserisci l'indirizzo nella colonna URL dei browser di altri computer per aprire il login",
newPassword:"nuova password",
ForgetPassword:"dimenticare la password",
ContactUs:"Contattaci/dai suggerimenti",
Actualpay_should_big_then_shouldpay:"Gli incassi effettivi non possono essere superiori ai crediti",
ShopAddress:"Indirizzo del mio negozio Scansiona il codice QR per effettuare un ordine",
Submit:"invia",
All:"Tutto",
OrdernumExists:"Il numero dell'ordine esiste già",
PermissionDenied:"permesso negato",
StockTransfer:"Trasferimento di titoli",
FromWarehouse:"Trasferimento fuori magazzino",
ToWarehouse:"Trasferimento al magazzino",
PleaseUseInWebBrowser:"Utilizza la funzione di esportazione Excel in Google Chrome",
PleasePrintInWebBrowser:"Si prega di utilizzare la funzione di stampa in Google Chrome",
HistoryPrice:"prezzo storico",
SerialNumber:"numero di serie",
Please_Use_In_APP:"Si prega di utilizzarlo all'interno del software del computer",
Please_Purchase_In_APP:"Si prega di acquistare tramite l'APP, non nel browser",
Connect_Postgresql_database_Default_database_is_sqlite_in_local:"Puoi connetterti al database Postgresql. I tuoi dati verranno archiviati nel database Postgresql. Per impostazione predefinita, non è necessario connettersi al database Postgresql. L'impostazione predefinita è il database Sqlite locale.",
Connect_Postgresql_database_data_will_store_in_Postgresql:"Connettiti al database Postgresql, i tuoi dati verranno archiviati nel database Postgresql e i dati verranno riletti",
Use_sqlite_data_will_store_in_local:"Utilizzando sqlite, i dati verranno archiviati sul computer locale",
UsePostgresqlDatabase:"Utilizzando il database PGSQL",
UseSqliteDatabase:"Utilizzando il database SQLite",
DatabaseName:"Banca dati dei nomi",
Test_connect:"verificare la connessione",
If_has_color_size_initstock_input_0_and_then_add_it_in_purchase:"Se il prodotto ha un colore o una taglia, inserisci 0 per l'inventario iniziale Dopo aver aggiunto il prodotto, inserisci l'inventario nell'acquisto.",
my:"mio",
my_shop_qrcode_scan:"Il codice QR del mio negozio offre ai clienti la possibilità di scansionare il codice per effettuare ordini. Il telefono cellulare del cliente deve essere collegato allo stesso router del tuo computer.",
ip:"IP",
port:"Porta",
orderstatus:"Lo stato dell'ordine",
image:"immagine",
Template:"modello",
Please_select_a_excel_file:"Seleziona un file",
Please_select_only_one_excel_file:"È possibile selezionare un solo file",
Connect_Internet_Login_again:"Connettersi a Internet ed effettuare nuovamente l'accesso prima dell'acquisto",

    productHasValidDate:'Il prodotto ha un periodo valido',
productHasColor:'Il prodotto ha dimensioni di colore',
GeneralGoods:'Beni generali',
Selected:'selezionata',
RestorePurchase:'Riprendi l’acquisto',
Buy_ElinkInvoice_Enterprise_Edition_OneUser:'Acquista in Fatturazione utenti Enterprise Edition 1 in modo permanente',
Buy_ElinkInvoice_EnterpriseEdition_Unlimited_Users:'La fatturazione di acquisto Enterprise Edition è illimitata per utenti e dispositivi',
Purchasing:'Acquisto ... Per favore aspetta pazientemente ...',
Validdate:'Periodo di validità',
Makedate:'Data di produzione',
Batch:'partita',
CheckVersion:'Controlla la versione',
Please_set_this_ip_address_on_App:'Si prega di impostare questo indirizzo IP o indirizzo IP del computer sull’APP.',
Open_this_link_on_other_Computer_and_Phone_connect_the_same_WiFi:'Apri questa connessione nel tuo computer o browser mobile (connetti lo stesso WiFi)',


    CheckVersion: 'Controlla la versione',
You_need_to_purchase: "Non hai ancora acquistato, per favore aggiungi WeChat a Elink9988 E-mail: bvbuy@qq.com",
Thank_for_your_purchase: "Hai già acquistato",
New_version_available: "C'è una nuova versione",
Is_the_latest_version: "è l'ultima versione",
    please:'per favore',
input:'ingresso',
wrong:'sbagliato',
Verifycode:'Verificare il codice',
Upload:'Caricare',
Download:'Scaricare',
You_need_to_purchase_to_continue_use:'È necessario acquistare per continuare l’uso',
CheckBuy:'Controlla l‘acquisto',
Exists:'esiste',
NetworkUnavailable:'Rete non disponibile',
Today:'Oggi',
Yesterday:'Ieri',
ThisMonth:'Questo mese',
LastMonth:'Lo scorso mese',
nickname:'nickname',
storeName:'nome del negozio',
BuyStandAlone:'Acquista la versione stand-alone',
PermissionDenied:'Permesso negato',
Boss:'Boss',
    login:'Accesso',
    operate:'Operare',
    register:'Registrare',
    username:'Nome utente',
    password:'Parola d\'ordine',
    User:'Utente',
    ok:'ok',
    back:'Indietro',
    success:'Successo',
    fail:'Fallire',
    cancel:'Annulla',
    add:'Inserisci',
    edit:'modificare',
    delete:'Elimina',
    refresh:'ricaricare',
    close:'Vicino',
    cancel:'Annulla',
    return:'Ritorno',
    ElinkInvoice:'Fattura Elink',
    Purchase:'Acquista',
    BaseData:'Dati di base',
    Sell:'Vendere',
    PurchaseReturns:'Ritorni di acquisto',
    SellReturns:'Vendi ritorni',
    Inventory:'Inventario',
    Statistics:'statistica',
    Receivable:'ricevibile',
    Payable:'pagabile',
    Orders:'Ordini',
    StockTransfer:'Trasferimento di scorta',
    StockRecall:'Stock di richiamo',
    Customer:'Cliente',
    Supplier:'Fornitore',
    Warehouse:'Magazzino',
    Color:'Colore',
    Size:'Taglia',
    Category:'Categoria',
    Category2:'Categoria2',
    Product:'Prodotto',
    Account:'account',
    AccountType:'Categoria di conto',
    Staff:'Personale',
    typeone:'Categoria',
    typetwo:'Sottocategoria',
    ProductName:'Nome del prodotto',
    Specification:'specificazione',
    Barcode:'Codice a barre',
    Buyprice:'Acquista il prezzo',
    Sellprice:'Prezzo di vendita',
    Wholesaleprice:'Prezzo all\'ingrosso',
    Currentstock:'Scorta attuale',
    Unit:'Unità',
    Initstock:'Stock iniziale',
    Parameter:'Parametro',
    Remark:'osservazione',
    Supplier:'Fornitore',
    Customer:'Cliente',
    Staff:'Personale',
    Receivable:'ricevibile',
    payable:'pagabile',
    Receipts:'ricevute',
    Paid:'Pagato',
    Preferential:'Preferenziale',
    DateDay:'Data',
    OrderNum:'Numero d\'ordine',
    Name:'Nome',
    UserName:'Nome utente',
    IdNum:'Numero di identificazione',
    BirthDay:'Compleanno',
    SEX:'Sesso',
    Female:'Femmina',
    Male:'Maschio',
    Select:'Selezionare',
    Address:'Indirizzo',
    Phone:'Telefono',
    Email:'E-mail',
    CardNum:'Numero di carta',
    Price:'Prezzo',
    QTY:'Quantità',
    SupplierCategory:'Categoria del fornitore',
    CustomerCategory:'Categoria cliente',
    Power:'Energia',
    Role:'Ruolo',
    save:'Salvare',
    image:'Immagine',
    search:'Ricerca',
    Year:'Anno',
    Month:'Mese',
    Day:'Giorno',
    Total:'Totale',
    WorkReport:'Rapporto di lavoro',
    Leave:'Partire',
    CheckIn:'Registrare',
    Announcement:'Annuncio',
    Approval:'Approvazione',
    Tracking:'puntamento',
    Bill:'Conto',
    OrdersDetail:'Dettaglio ordini',
    Expense:'Spese',
    Income:'Reddito',
    Userfor:'Userfor',
    Amount:'Quantità',
    Title:'Titolo',
    News:'notizia',
    SelectFile:'Seleziona il file',
    Content:'Soddisfare',
    Cost:'Costo',
    ApprovalUser:'Utente di approvazione',
    ApprovalStatus:'Stato di approvazione',
    ApprovalRemark:'Nota di Approvazione',
    ApprovalDate:'Data di approvazione',
    SubmitDate:'Data di invio',
    Status:'Stato',
    FromDateTime:'Dalla data',
    ToDateTime:'A data Ora',
    Subject:'Soggetto',
    Latitude:'Latitudine',
    Longitude:'Longitudine',
    Print:'Stampare',
    DataTrans:'DataTrans',
    OA:'OA',
    Setting:'Ambientazione',
    Help:'Aiuto',
    ScanOpenInPhone:'Scansione Apri nel telefono',
    Building:'Costruzione',
    Room:'Camera',
    HotelCheckIn:'Registrare',
    CheckOut:'Check-out',
    Hotel:'Hotel',
    Checkintime:'Check in tempo',
    Checkouttime:'Orario di partenza',
    Deposit:'Depositare',
    Cost:'Costo',
    RoomNum:'Stanza Num',
    Rent:'Affitto',
    costday:'costday',
    rent:'affitto',
    waternum:'Laurea in acqua',
    electricnum:'Grado elettrico',
    gasnum:'Grado del gas',
    watercost:'costo dell\'acqua',
    electriccost:'costo elettrico',
    gascost:'costo del gas',
    cleaningcost:'costi di pulizia',
    networkcost:'costo di rete',
    tvcost:'costo della tv',
    managecost:'gestire i costi',
    othercost:'altro costo',
    totalcost:'costo totale',
    remark:'osservazione',
    addtime:'aggiungi tempo',
    OpenInBrowser:'Apri nel browser',
    InventoryProfit:'Profitto di inventario',
    InventoryLoss:'Perdita di inventario',
    Buy:'Acquistare',



Refresh:'Aggiorna',
Add:'Aggiungi',
Search:'Cerca',
Records:'record',
}



// WEBPACK FOOTER //
// ./src/lang/it.js